import { Component } from 'preact-compat';
import cn from 'classnames';
import PropTypes from 'prop-types';
import Three from '../three/three';
import Rotation from '../rotation/rotation';
import s from './scss/threeSixtyStage.scss';

export default class ThreeSixtyStage extends Component {
  static propTypes = {
    lang: PropTypes.string.isRequired,
    imgPath: PropTypes.string.isRequired,
    zoomClicked: PropTypes.func.isRequired,
    zoomStopped: PropTypes.func.isRequired,
    zoomFactor: PropTypes.number.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      stageType: 'exterior',
      currentFrame: 0,
      percentLoaded: 0,
      moved: false
    };
    this.getAngle();
  }

  setFrame = frame => {
    this.setState({
      currentFrame: frame,
      moved: true
    });
  };

  changeStage = () => {
    const { stageType } = this.state;

    this.setState({
      stageType: stageType === 'exterior' ? 'interior' : 'exterior'
    });

    this.props.resetLoad();
  };

  componentDidMount() {
    window.addEventListener('orientationchange', this.getSize);
    window.addEventListener('resize', this.getSize);
  }

  componentWillUnmount() {
    window.removeEventListener('orientationchange', this.getSize);
    window.removeEventListener('resize', this.getSize);
  }

  getSize = () => {
    const { stageType } = this.state;
    const { vw } = this.props;
    // images are 112% if VP <= 500
    const strech = vw <= 500 ? 1.12 : 1;
    const stageWidth = this[stageType].offsetWidth;
    const stageHeight =
      stageType === 'exterior'
        ? this.exterior.offsetHeight
        : (stageWidth / 2) * strech;

    const previewWidth = this.previewimg.offsetWidth;

    this.setState({
      stageWidth,
      stageHeight,
      previewWidth
    });
  };

  getAngle = () => {
    const angleAmount = 36;
    const angles = [];
    for (let i = 1; i <= angleAmount; i++) {
      const angle = i < 10 ? `100${i}` : `10${i}`;
      angles.push(angle);
    }
    this.setState({
      angles
    });
  };

  render() {
    const { absPath, lang, loadHandling, imgPath, vw } = this.props;

    const {
      angles,
      currentFrame,
      moved,
      stageHeight,
      stageType,
      stageWidth,
      previewWidth
    } = this.state;

    let exteriorText;
    let interiorText;

    if (lang === 'en' || lang === 'kr' || lang === 'ne') {
      exteriorText = 'VIEW EXTERIOR';
      interiorText = 'VIEW INTERIOR';
    } else if (lang === 'es' || lang === 'pt') {
      exteriorText = 'VISTA EXTERIOR';
      interiorText = 'VISTA INTERIOR';
    } else if (lang === 'me') {
      exteriorText = 'اكتشف التصميم الخارجي';
      interiorText = 'اكتشف التصميم الداخلي';
    }

    const previewImgSrc =
      stageType === 'exterior'
        ? absPath + 'assets/images/previewInt.jpg'
        : absPath + `assets/images/${imgPath}ext/image.${angles[0]}.jpg`;

    return (
      <div>
        <div className={s.preview} onClick={this.changeStage}>
          <div className={s.img}>
            <img
              ref={previewimg => (this.previewimg = previewimg)}
              id="previewImg"
              src={previewImgSrc}
              style={{
                height: previewWidth / 2
              }}
            />
          </div>
          <div className={s.text}>
            <span>
              {stageType === 'exterior' ? interiorText : exteriorText}
            </span>
          </div>
        </div>
        <div className={cn(s.threeSixtyIcon, moved && s.fadeout)} />
        {stageType === 'exterior' ? (
          <div
            id="exterior"
            className={s.original}
            ref={exterior => (this.exterior = exterior)}
          >
            <Rotation
              cycle
              reverse
              current={currentFrame}
              setFrame={this.setFrame}
              vw={vw}
              scroll={false}
            >
              {angles.map((angle, i) => {
                return (
                  <img
                    key={angle}
                    src={
                      absPath + `assets/images/${imgPath}ext/image.${angle}.jpg`
                    }
                    onLoad={() => {
                      i === 0 && this.getSize();
                      loadHandling(36);
                    }}
                  />
                );
              })}
            </Rotation>
          </div>
        ) : (
          <div id="interior" ref={interior => (this.interior = interior)}>
            <Three
              stageWidth={stageWidth}
              stageHeight={stageHeight}
              loadHandling={loadHandling}
              imgPath={imgPath}
              absPath={absPath}
              zoomStopped={this.props.zoomStopped}
              zoomFactor={this.props.zoomFactor}
              carline={this.props.carline}
            />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/threeSixtyStage/threeSixtyStage.js